let listenersRegistered = false

export default defineNuxtPlugin({
  name: 'hardware-back',
  enforce: 'post',
  async setup() {
    if (!import.meta.client) {
      return
    }

    const { Capacitor } = await import('@capacitor/core')
    if (!Capacitor.isNativePlatform()) {
      return
    }

    if (listenersRegistered) {
      return
    }
    listenersRegistered = true

    const { App } = await import('@capacitor/app')
    const { closeTopModal } = useCloseTopModal()

    await App.addListener('backButton', ({ canGoBack }) => {
      if (closeTopModal()) {
        return
      }

      if (canGoBack) {
        window.history.back()
        return
      }

      void App.exitApp()
    })
  },
})
